// Environment variables are accessed through process.env
// Note: In Create React App, only variables prefixed with REACT_APP_ are accessible
const config = {
  mixpanelToken: process.env.REACT_APP_MIXPANEL_TOKEN || "",
  geminiApiKey: process.env.REACT_APP_GEMINI_API_KEY || "",
  geminiApiKeys: (process.env.REACT_APP_GEMINI_API_KEYS || "").split(","),
};

export default config;

// Add this to verify the API key is loaded
console.log("Config loaded - API Key exists:", !!config.geminiApiKey);
